import { Autocomplete, Box, CircularProgress, MenuItem } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { Wallet } from '../interfaces/Wallet';
import useWallets from '../customhooks/wallets/useWallets';
import { getFormattedAmount } from '../shared/getFormattedAmount';
import { InfoCircleIcon } from './icons';
import CustomTextField from './CustomTextInput';

export const WalletSelect = (props: {
    value?: number | string;
    disabled?: boolean;
    onHandleChange: (value: Wallet) => void;
    options?: Wallet[];
}) => {
    const [selected, setSelected] = useState<Wallet>({} as Wallet);
    const { isLoading, wallets } = useWallets();
    const { value, onHandleChange, options = wallets, disabled } = props;

    useEffect(() => {
        if (value) {
            const found = options.find(
                ({ id, currency }) => id === value || currency === value
            );

            if (found) {
                setSelected(found);
            }
        }
    });

    return (
        <Box className='space-y-1'>
            <Autocomplete
                placeholder='0.00'
                disableClearable
                disabled={disabled}
                renderInput={(params) => (
                    <CustomTextField
                        params={params}
                        label='Select Wallet'
                        placeholder='Wallets'
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: isLoading && (
                                <Fragment>
                                    <CircularProgress size={20} />
                                    {params.InputProps.endAdornment}
                                </Fragment>
                            )
                        }}
                        disabled={disabled}
                    />
                )}
                noOptionsText={'No data available'}
                renderOption={(props, option) => (
                    <MenuItem
                        {...props}
                        value={option.id}
                        key={`wallet-${option.id}`}
                    >
                        {`${option.currency} Wallet`}
                    </MenuItem>
                )}
                getOptionLabel={(option) =>
                    option.currency ? `${option.currency} Wallet` : ''
                }
                onChange={(_, value) => onHandleChange(value)}
                options={options}
                value={selected}
            />
            {selected && (
                <Box className='flex items-center gap-2 h-8 px-4 bg-whiteLilac'>
                    <InfoCircleIcon />
                    <p className='text-slate'>
                        Available balance is{' '}
                        <span className='font-semibold'>
                            {getFormattedAmount({
                                amount: selected.walletBalance || 0,
                                currency: selected.currency ?? 'NGN'
                            })}
                        </span>
                    </p>
                </Box>
            )}
        </Box>
    );
};
